export const depositSuccessState = {
  title: 'Deposit success',
  icon: 'icon-terminal-deposit-success',
  description: 'Your deposit has been successfully made',
};

export const withdrawSuccessState = {
  title: 'Withdrawal Success',
  icon: 'icon-terminal-withdraw',
  description: 'Your withdraw has been successfully made',
};

export const depositSearchPlayer = {
  title: 'Deposit',
  description: 'Enter your ID or login to make a deposit',
};

export const withdrawSearchPlayer = {
  title: 'Withdraw',
  description: 'Enter your id or login to make a withdraw',
};

export const SearchTabTypes = {
  PLAYER_ID: 1,
  USERNAME: 2,
};

export const searchTabs  = [
  {
    value: SearchTabTypes.PLAYER_ID,
    name: 'Search by player id'
  },
  {
    value: SearchTabTypes.USERNAME,
    name: 'Search by username',
  },
];
